export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14711.95cb8d4b.jpg";